export default {
    methods: {
        getImage(image, requirePath = true) {
            return requirePath ? process.env.VUE_APP_URL + require('../assets/' + image) : process.env.VUE_APP_URL + image;
        }
    }
}